
import { misContribuyenteService } from "../../../_services/misContribuyentes.service";
import { dashboardConstants } from "../constants";

export const getContribuyentes = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await misContribuyenteService.getContribuyentes(data);

    if (!Array.isArray(response)) {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED, payload: { contList: [] } };
  }
  function failure(error) {
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.SET_CONT_LIST, payload: list };
  }
};


export const getContribuyente = (id) => async (dispatch) => {
  dispatch(request());
  try {
    const data = await misContribuyenteService.getContribuyente(id);
    if (typeof data === "string") {
      dispatch(failure(data));
    } else {
      dispatch(success(data));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(error) {
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.SET_CONTRIBUYENTE, payload: list };
  }
};


export const editContribuyente = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const result = await misContribuyenteService.editContribuyente(data);

    if (typeof result === "string") {
      dispatch(failure(result));
    } else {
      dispatch(success(result));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }
  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(payload) {
    return { type: dashboardConstants.FETCH_SUCCESS, payload };
  }
};

export const editInmueble = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const result = await misContribuyenteService.editInmueble(data);

    if (typeof result === "string") {
      dispatch(failure(result));
      return { error: true };
    } else {
      dispatch(success(result));
      return { success: true };
    }
  } catch (error) {
    dispatch(failure(error.toString()));
    return { error: true };
  }
  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(payload) {
    return { type: dashboardConstants.FETCH_SUCCESS, payload };
  }
};
